export enum MicrosoftCloudSettingsSections {
  PREREQUISITES = 'prerequisites',
  MPC_ACCOUNT_DETAILS = 'mpcAccountDetails',
  MICROSOFT_PRODUCT_DETAILS = 'microsoftProductDetails',
  LINK_MPC_ACCOUNT = 'linkMpcAccount',
  STEPS = 'steps',
}
export type MicrosoftCloudSettingsSectionsProps = {
  [MicrosoftCloudSettingsSections.PREREQUISITES]: Prerequisites
  [MicrosoftCloudSettingsSections.MPC_ACCOUNT_DETAILS]: MPCAccountDetails
  [MicrosoftCloudSettingsSections.MICROSOFT_PRODUCT_DETAILS]: MicrosoftProductDetails
  [MicrosoftCloudSettingsSections.LINK_MPC_ACCOUNT]: LinkMpcAccount
  [MicrosoftCloudSettingsSections.STEPS]: MicrosoftCloudSettingsSteps
}
export interface Prerequisites {
  hasMPCAccessAsAdmin: boolean
  hasSeparateUserForLabraIntegration: boolean
  hasConfiguredSolutionWithMPC: boolean
}
export interface MPCAccountDetails {
  partnerType: string[] | null
  isISV: boolean | null
  isConsultingPartner: boolean | null
  mpnID: string | null
  accountName: string | null
  _partnerTypeValidation?: string
}
export interface LinkMpcAccount {
  isMPCConnected: boolean
}

export interface ProductDetails {
  id: string
  solutionName: string
  solutionId: string
  publisherName: string
  solutionType: string | null
}

export interface MicrosoftProductDetails {
  productDetails: ProductDetails[]
}

export interface MicrosoftCloudSettingsSteps {
  prerequisites: boolean
  mpcAccountDetails: boolean
  microsoftProductDetails: boolean
  linkMpcAccount: boolean
}

export const initialValues: MicrosoftCloudSettingsSectionsProps = {
  [MicrosoftCloudSettingsSections.PREREQUISITES]: {
    hasMPCAccessAsAdmin: false,
    hasSeparateUserForLabraIntegration: false,
    hasConfiguredSolutionWithMPC: false,
  },
  [MicrosoftCloudSettingsSections.MPC_ACCOUNT_DETAILS]: {
    partnerType: [],
    isISV: false,
    isConsultingPartner: false,
    mpnID: '',
    accountName: '',
  },
  [MicrosoftCloudSettingsSections.LINK_MPC_ACCOUNT]: {
    isMPCConnected: false,
  },
  [MicrosoftCloudSettingsSections.MICROSOFT_PRODUCT_DETAILS]: {
    productDetails: [
      {
        id: `${Math.floor(Math.random() * 10000)}`,
        solutionName: '',
        solutionId: '',
        publisherName: '',
        solutionType: '',
      },
    ],
  },
  [MicrosoftCloudSettingsSections.STEPS]: {
    prerequisites: false,
    mpcAccountDetails: false,
    microsoftProductDetails: false,
    linkMpcAccount: false,
  },
}
export type MicrosoftSections =
  | 'prerequisites'
  | 'mpcAccountDetails'
  | 'microsoftProductDetails'
  | 'linkMpcAccount'
